import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { fontUi } from '../../theme/typography';

export const StyledCareerHistoryLink = styled(Link)`
  ${fontUi};
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: ${({ theme }) => theme.text};
  font-size: 11px;
  font-weight: 700;
  line-height: 1.15;
  text-align: center;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.isDark ? theme.headerAccent : theme.success};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.success};
    outline-offset: 4px;
    border-radius: 6px;
  }
`;

export const StyledCareerIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: ${({ theme }) => theme.hover};
  color: ${({ theme }) => theme.textMuted};

  svg {
    width: 14px;
    height: 14px;
  }
`;
